var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var keyCodes = {
    esc: 27,
    space: 32,
    enter: 13,
    tab: 9,
    up: 38,
    down: 40,
    home: 36,
    end: 35,
    n: 78,
    p: 80,
};
function getTarget(target, allElements) {
    var els = findDOMElements(target);
    if (allElements) {
        if (isArrayOrNodeList(els)) {
            return els;
        }
        if (els === null) {
            return [];
        }
        return [els];
    }
    else {
        if (isArrayOrNodeList(els)) {
            return els[0];
        }
        return els;
    }
}
function isArrayOrNodeList(els) {
    if (els === null) {
        return false;
    }
    return Array.isArray(els) || (canUseDOM && typeof els.length === 'number');
}
function findDOMElements(target) {
    if (typeof target === 'string' && canUseDOM) {
        var selection = document.querySelectorAll(target);
        if (!selection.length) {
            selection = document.querySelectorAll("#" + target);
        }
        if (!selection.length) {
            throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
        }
        return selection;
    }
    return target;
}
var canUseDOM = !!(typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
function isInDOMSubtrees(element, subtreeRoots) {
    if (subtreeRoots === void 0) { subtreeRoots = []; }
    return (subtreeRoots &&
        subtreeRoots.length &&
        subtreeRoots.find(function (subTreeRoot) { return isInDOMSubtree(element, subTreeRoot); }));
}
function isInDOMSubtree(element, subtreeRoot) {
    return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
}
function deleteChildren(props) {
    var newProps = __assign({}, props);
    delete newProps.children;
    return newProps;
}
export { deleteChildren, isArrayOrNodeList, getTarget, findDOMElements, isInDOMSubtrees, isInDOMSubtree, };
//# sourceMappingURL=Utils.js.map